import { $getRoot, $getSelection, FORMAT_TEXT_COMMAND, UNDO_COMMAND, REDO_COMMAND } from 'lexical'
import React, { useCallback, useEffect, useState } from 'react'
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted'
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered'
import TableChartOutlined from '@material-ui/icons/TableChartOutlined'

import { LexicalComposer } from '@lexical/react/LexicalComposer'
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin'
import { ContentEditable } from '@lexical/react/LexicalContentEditable'
import { HistoryPlugin } from '@lexical/react/LexicalHistoryPlugin'
import { OnChangePlugin } from '@lexical/react/LexicalOnChangePlugin'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import CloudDoneOutlinedIcon from '@material-ui/icons/CloudDoneOutlined'
import CachedRoundedIcon from '@material-ui/icons/CachedRounded'

import { INSERT_ORDERED_LIST_COMMAND, INSERT_UNORDERED_LIST_COMMAND, ListNode, ListItemNode, REMOVE_LIST_COMMAND } from '@lexical/list'

import { ListPlugin } from '@lexical/react/LexicalListPlugin'

import { INSERT_TABLE_COMMAND, TableNode, TableRowNode, TableCellNode } from '@lexical/table'
import { TablePlugin } from '@lexical/react/LexicalTablePlugin'

import { HeadingNode, QuoteNode } from '@lexical/rich-text'

import { $generateHtmlFromNodes, $generateNodesFromDOM } from '@lexical/html'

import { $convertFromMarkdownString, $convertToMarkdownString, TRANSFORMERS } from '@lexical/markdown'

const theme = {
  /* –––––  Text / paragraph / lists ––––– */
  // paragraph: 'mb-2',                 // margin-bottom like <p> in Bootstrap
  // text: '',                          // keep default font-size/line-height
  // heading: {
  //     h1: 'h1',                        // Bootstrap heading utilities
  //     h2: 'h2',
  //     h3: 'h3',
  // },
  // list: {
  //     ul: 'ps-4',                      // padding-start for bullets
  //     ol: 'ps-4',
  // },

  /* –––––  Table styling ––––– */
  table: 'table table-bordered justify-content-center w-100 my-3', // core Bootstrap table look
  // tableRow: '',                               // no extra row rule needed
  tableCell: 'align-middle', // vertical-top like <td>
  // tableCellHeader: 'table-light fw-semibold', // light background & bold text

  // /* Optional handles if you expose Lexical’s “➕” buttons */
  // tableAddColumns: 'cursor-pointer',
  // tableAddRows: 'cursor-pointer',

  // /* Selection outline (Bootstrap has no built-in util) */
  // tableSelected: 'lexical-selected',          // custom class, see CSS below
}

/* ——————————————— Toolbar ——————————————— */

function ToolbarPlugin({ saving }: { saving: boolean }) {
  const [editor] = useLexicalComposerContext()

  const dispatch = useCallback((cmd, payload?) => editor.dispatchCommand(cmd, payload), [editor])

  return (
    <div className='justify-content-between' style={styles.toolbar}>
      <div>
        <button style={styles.btn} onClick={() => dispatch(FORMAT_TEXT_COMMAND, 'bold')}>
          B
        </button>
        <button style={styles.btn} onClick={() => dispatch(FORMAT_TEXT_COMMAND, 'italic')}>
          I
        </button>
        <button style={styles.btn} onClick={() => dispatch(FORMAT_TEXT_COMMAND, 'underline')}>
          U
        </button>

        <span style={styles.divider} />

        {/* lists */}
        <button style={styles.btn} onClick={() => dispatch(INSERT_UNORDERED_LIST_COMMAND)}>
          <FormatListBulletedIcon fontSize='small' />
        </button>
        <button style={styles.btn} onClick={() => dispatch(INSERT_ORDERED_LIST_COMMAND)}>
          <FormatListNumberedIcon fontSize='small' />
        </button>
      </div>
      <div>
        <div style={{ display: 'flex', columnGap: 5, marginRight: 10 }}>
          {saving && (
            <>
              <CachedRoundedIcon />
              <p style={{ margin: 'auto' }}>Saving...</p>
            </>
          )}
          {!saving && (
            <>
              <CloudDoneOutlinedIcon />
              <p style={{ margin: 'auto' }}>Saved</p>
            </>
          )}
        </div>
      </div>
      {/* text formatting */}
      {/* <button style={styles.btn} onClick={() => dispatch(REMOVE_LIST_COMMAND)}>Ⓧ</button> */}

      {/* <span style={styles.divider} /> */}

      {/* 👉 table */}
      {/* <button
                style={styles.btn}
                onClick={() =>
                    dispatch(INSERT_TABLE_COMMAND, {
                        rows: 3,
                        columns: 3,
                        includeHeaders: false,
                    })
                }
            >
                <TableChartOutlined fontSize='small' />
            </button> */}

      {/* <span style={styles.divider} />

            <button style={styles.btn} onClick={() => dispatch(UNDO_COMMAND)}>↶</button>
            <button style={styles.btn} onClick={() => dispatch(REDO_COMMAND)}>↷</button> */}
    </div>
  )
}
/* —————————————————————————————— Other helpers —————————————————————————————— */

function MyCustomAutoFocusPlugin() {
  const [editor] = useLexicalComposerContext()
  useEffect(() => editor.focus(), [editor])
  return null
}

function onChangeHandler(editorState, onChangeCb) {
  editorState.read(() => {
    const textContent = $getRoot().getTextContent()
    console.log($getRoot(), $getSelection())
    onChangeCb?.(textContent)
  })
}

function onError(error: Error) {
  throw error
}

// interface MarkdownImportExportPluginProps {
//     initialMarkdown?: string;           // ⇢ string you want to load
//     onMarkdownChange?: (md: string) => void; // ⇢ gets called after every edit
// }

// export default function MarkdownImportExportPlugin({
//     onMarkdownChange,
// }: MarkdownImportExportPluginProps) {
//     const [editor] = useLexicalComposerContext();

//     // /* ----------  IMPORT once (or when prop changes)  ---------- */
//     useEffect(() => {
//         if (!initialMarkdown) return;
//         editor.update(() => {
//             console.log("here");
//             $convertFromMarkdownString(initialMarkdown, TRANSFORMERS);
//         });
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     /* ----------  EXPORT on every editor update  ---------- */
//     useEffect(() => {
//         return editor.registerUpdateListener(({ editorState }) => {
//             // run inside read phase
//             editorState.read(() => {
//                 const md = $convertToMarkdownString(TRANSFORMERS);
//                 onMarkdownChange?.(md);
//             });
//         });
//     }, [editor, onMarkdownChange]);

//     return null;                       // plugin renders nothing
// }

/* ——————————————————————————————— Editor ——————————————————————————————— */

/** Inject initial HTML into the editor once, right after mount. */
function HTMLImportPlugin({ html }: { html: string }) {
  const [editor] = useLexicalComposerContext()

  React.useEffect(() => {
    if (!html) return

    editor.update(() => {
      const parser = new DOMParser()
      const dom = parser.parseFromString(html, 'text/html')
      console.log(dom)
      const nodes = $generateNodesFromDOM(editor, dom)

      // wipe whatever is there (the empty paragraph from Lexical)
      $getRoot().clear()
      $getRoot().append(...nodes)
    })
    // fire only once – don’t re-run on every prop change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return null
}

/** Convert the current editor state to HTML on every change. */
function HTMLExportPlugin({ onChange }: { onChange: (html: string) => void }) {
  const [editor] = useLexicalComposerContext()

  return (
    <OnChangePlugin
      onChange={(state) => {
        state.read(() => {
          const html = $generateHtmlFromNodes(editor)
          onChange(html)
        })
      }}
    />
  )
}

/* ---- main editor component -------------------------------------------- */

export function TextEditor({ initialHtml, onChangeCb }: { initialHtml: string; onChangeCb: (val: string) => Promise<void> }) {
  const [saving, setSaving] = useState<boolean>(false)
  const [curContent, setCurContent] = useState<string>(initialHtml)
  const initialConfig = {
    namespace: 'MyEditor',
    theme,
    onError,
    nodes: [TableNode, TableRowNode, TableCellNode, ListNode, ListItemNode, HeadingNode, QuoteNode],
  }

  async function onContentUpdate(content: string) {
    if (curContent !== content) {
      setCurContent(content)
    }
  }

  useEffect(() => {
    setSaving(true)
    const id = setTimeout(async () => {
      setSaving(true)
      await onChangeCb(prependInlineCss(theme, curContent))
      setSaving(false)
    }, 1500)
    return () => clearTimeout(id)
  }, [curContent, onChangeCb])

  return (
    <div id='rte-kai'>
      <LexicalComposer initialConfig={initialConfig}>
        {/* Toolbar (unchanged) */}
        <ToolbarPlugin saving={saving} />

        {/* Editable area */}
        <RichTextPlugin contentEditable={<ContentEditable style={styles.editable} />} ErrorBoundary={undefined as any} />

        {/* Core plugins */}
        <HistoryPlugin />
        <ListPlugin />
        <TablePlugin />
        <MyCustomAutoFocusPlugin />

        {/* NEW: HTML import & export */}
        <HTMLImportPlugin html={initialHtml} />
        <HTMLExportPlugin onChange={onContentUpdate} />
      </LexicalComposer>
    </div>
  )
}

/**
 * Recursively collect every string value in the theme object.
 */
function collectClasses(theme: any, acc = new Set<string>()) {
  for (const value of Object.values(theme)) {
    if (typeof value === 'string') {
      value
        .split(/\s+/) // handle "font-bold underline"
        .filter(Boolean)
        .forEach((cls) => acc.add(cls))
    } else if (value && typeof value === 'object') {
      collectClasses(value, acc)
    }
  }
  return acc
}

/**
 * Gather CSS text for the given class names by scanning same-origin stylesheets.
 */
function scrapeCssForClasses(classNames: Set<string>): string {
  let css = ''

  // Only same-origin stylesheets are accessible; cross-origin are skipped automatically.
  for (const sheet of Array.from(document.styleSheets) as CSSStyleSheet[]) {
    let rules: CSSRuleList
    try {
      rules = sheet.cssRules // Can throw SecurityError on CORS sheets
    } catch {
      continue
    }

    for (const rule of Array.from(rules) as CSSRule[]) {
      if (rule.type !== CSSRule.STYLE_RULE) continue
      const selector = (rule as CSSStyleRule).selectorText

      // Does the selector reference *any* of our classes?
      if ([...classNames].some((cn) => selector.includes(`.${cn}`))) {
        css += `${rule.cssText}\n`
      }
    }
  }

  return css
}

/**
 * Produce final HTML with a <style> tag inlined at the top.
 */
export function prependInlineCss(theme: any, html: string): string {
  const classes = collectClasses(theme)
  const cssText = scrapeCssForClasses(classes)

  if (!cssText.trim()) return html // nothing found

  const styleTag = `<head><style>\n${cssText}</style></head>\n`
  return styleTag + html
}

/* ——————————————————————————————— Styles ——————————————————————————————— */

const styles: Record<string, React.CSSProperties> = {
  toolbar: {
    display: 'flex',
    gap: '.25rem',
    alignItems: 'center',
    padding: '.5rem',
    borderBottom: '1px solid #ddd',
    background: '#f9f9f9',
    position: 'sticky',
    top: 0,
    zIndex: 1,
  },
  btn: {
    fontSize: '0.9rem',
    padding: '.25rem .5rem',
    border: '1px solid #ccc',
    background: '#fff',
    cursor: 'pointer',
    borderRadius: 4,
  },
  divider: {
    flex: '0 0 1px',
    height: '1.25rem',
    background: '#ddd',
    margin: '0 .25rem',
  },
  editable: {
    minHeight: 200,
    padding: '1rem',
  },
}
